import { render, staticRenderFns } from "./createCoupon.vue?vue&type=template&id=b9a50456&"
import script from "./createCoupon.vue?vue&type=script&lang=js&"
export * from "./createCoupon.vue?vue&type=script&lang=js&"
import style0 from "./createCoupon.vue?vue&type=style&index=0&id=b9a50456&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports